import { useState, useEffect } from 'react'
import { X, Film, Clock, Tag } from 'lucide-react'
import { useAuth } from '../../../context/AuthContext'

export default function CollectionPreview({ collectionId, onClose }) {
  const { api } = useAuth()
  
  const [loading, setLoading] = useState(true)
  const [collection, setCollection] = useState(null)
  const [videos, setVideos] = useState([])
  const [error, setError] = useState(null)

  useEffect(() => {
    async function loadPreview() {
      setLoading(true)
      setError(null)
      try {
        const data = await api(`/vod/collections/${collectionId}/preview`)
        setCollection(data.collection)
        setVideos(data.videos || [])
      } catch (e) {
        setError(e.message)
      }
      setLoading(false)
    }
    loadPreview()
  }, [collectionId, api])

  function formatDuration(secs) {
    if (!secs) return ''
    const h = Math.floor(secs / 3600)
    const m = Math.floor((secs % 3600) / 60)
    if (h > 0) return `${h}h ${m}m`
    return `${m}m`
  }

  return (
    <div className="preview-modal-overlay" onClick={onClose}>
      <div className="preview-modal" onClick={e => e.stopPropagation()}>
        <div className="preview-modal-header">
          <h2><Film size={20} /> Collection Preview</h2>
          <button onClick={onClose}><X size={20} /></button>
        </div>

        {loading ? (
          <div className="preview-loading">Loading preview...</div>
        ) : error ? (
          <div className="preview-error">Error: {error}</div>
        ) : (
          <>
            <div className="preview-collection-info">
              <h3>{collection?.name}</h3>
              <div className="preview-meta">
                <span><Tag size={14} /> {collection?.query_tags}</span>
                <span>Query: {collection?.query_type}</span>
                <span>Sort: {collection?.sort_order}</span>
              </div>
              <div className="preview-count">
                {videos.length} video{videos.length !== 1 ? 's' : ''} match{videos.length === 1 ? 'es' : ''}
              </div>
            </div>

            <div className="preview-videos-list">
              {videos.length === 0 ? (
                <div className="preview-empty">
                  No videos match this collection's criteria.
                  <br />
                  Make sure videos are <strong>Active</strong> and have matching tags.
                </div>
              ) : (
                videos.map(video => (
                  <div key={video.tbtv_id} className="preview-video-item">
                    <div className="preview-thumb">
                      {video.thumbnail_url ? (
                        <img src={video.thumbnail_url} alt="" />
                      ) : (
                        <div className="thumb-placeholder"><Film size={20} /></div>
                      )}
                    </div>
                    <div className="preview-video-info">
                      <div className="preview-video-title">{video.title}</div>
                      <div className="preview-video-meta">
                        {video.duration && (
                          <span><Clock size={12} /> {formatDuration(video.duration)}</span>
                        )}
                        {video.release_date && (
                          <span>{video.release_date}</span>
                        )}
                      </div>
                      {video.tags && video.tags.length > 0 && (
                        <div className="preview-video-tags">
                          {video.tags.slice(0, 5).map(t => (
                            <span key={t} className="tag-mini">{t}</span>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                ))
              )}
            </div>
          </>
        )}
      </div>
    </div>
  )
}
